/* ============================================================
   EDA BABY CARE — THEME JS
   ============================================================ */
'use strict';

var EDA = (function () {

  /* ── Helpers ── */
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function formatMoney(cents) {
    return '₹' + (Math.round(cents) / 100).toLocaleString('en-IN');
  }

  /* ────────────────────────────────────────
     CART API
  ──────────────────────────────────────── */
  var Cart = {
    async get() {
      var r = await fetch('/cart.js');
      return r.json();
    },
    async add(variantId, qty) {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: qty || 1 })
      });
      if (!r.ok) {
        var err = await r.json();
        throw new Error(err.description || 'Could not add to cart');
      }
      return r.json();
    },
    async change(line, qty) {
      var r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      });
      return r.json();
    },
    updateCountUI(n) {
      qsa('.js-cart-count').forEach(function(el) { el.textContent = n; });
      qsa('.js-drawer-count').forEach(function(el) { el.textContent = n; });
    }
  };

  /* ────────────────────────────────────────
     CART DRAWER
  ──────────────────────────────────────── */
  var drawerEl, overlayEl, drawerBodyEl, drawerSubtotalEl;

  function initDrawer() {
    drawerEl        = qs('#CartDrawer');
    overlayEl       = qs('.js-cart-overlay');
    drawerBodyEl    = qs('.js-cart-body');
    drawerSubtotalEl = qs('.js-drawer-subtotal');

    if (!drawerEl) return;

    on(qs('.js-cart-close'), 'click', closeDrawer);
    on(overlayEl, 'click', closeDrawer);
    on(document, 'keydown', function(e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* Cart icon — open drawer */
    on(document, 'click', function(e) {
      var trigger = e.target.closest('[data-cart-trigger]');
      if (!trigger) return;
      e.preventDefault();
      openDrawerWithRefresh();
    });

    /* Drawer qty buttons — match both server-rendered and AJAX-rendered classes */
    on(drawerBodyEl, 'click', async function(e) {
      var dec = e.target.closest('.js-drawer-dec, .js-drawer-item-dec');
      var inc = e.target.closest('.js-drawer-inc, .js-drawer-item-inc');
      if (!dec && !inc) return;
      var line = parseInt((dec || inc).dataset.line, 10);
      var row  = qs('.cart-item[data-line="' + line + '"]', drawerBodyEl);
      var qtyEl = row && (row.querySelector('.js-item-qty') || row.querySelector('.js-drawer-item-qty'));
      var cur  = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
      await Cart.change(line, dec ? Math.max(0, cur - 1) : cur + 1);
      await openDrawerWithRefresh();
    });
  }

  function openDrawer() {
    if (!drawerEl) return;
    drawerEl.classList.add('is-open');
    if (overlayEl) overlayEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    if (overlayEl) overlayEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async function openDrawerWithRefresh() {
    var cart = await Cart.get();
    Cart.updateCountUI(cart.item_count);
    if (drawerSubtotalEl) drawerSubtotalEl.textContent = formatMoney(cart.total_price);
    if (drawerBodyEl) renderDrawerItems(cart);
    openDrawer();
  }

  /* Expose so bundle JS can call it */
  window.__edaOpenCart = openDrawerWithRefresh;

  function renderDrawerItems(cart) {
    if (!drawerBodyEl) return;
    if (cart.item_count === 0) {
      drawerBodyEl.innerHTML =
        '<div style="padding:48px 24px;text-align:center">' +
          '<p style="font-size:17px;font-weight:500;margin-bottom:20px">your cart is empty</p>' +
          '<a href="/collections/all" style="display:inline-block;padding:12px 28px;background:#2E4A38;color:#FBF9F5;border-radius:999px;font-size:15px;text-decoration:none">browse products</a>' +
        '</div>';
      return;
    }
    drawerBodyEl.innerHTML = cart.items.map(function(item, i) {
      var imgSrc = item.image ? item.image : '';
      var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      return '<div class="cart-item" data-line="' + (i + 1) + '">' +
        '<div class="cart-item__image">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" width="80" height="80" loading="lazy" style="width:100%;height:100%;object-fit:cover">' : '') +
        '</div>' +
        '<div>' +
          '<div class="cart-item__name">' + item.product_title + '</div>' +
          (variantTitle ? '<div class="cart-item__variant">' + variantTitle + '</div>' : '') +
          '<div class="cart-item__footer">' +
            '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '<div class="cart-item__qty">' +
              '<button type="button" class="cart-item__qty-btn js-drawer-dec" data-line="' + (i + 1) + '" aria-label="Decrease">–</button>' +
              '<span class="js-item-qty">' + item.quantity + '</span>' +
              '<button type="button" class="cart-item__qty-btn js-drawer-inc" data-line="' + (i + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  /* ────────────────────────────────────────
     ADD TO CART (AJAX — does NOT block GoKwik)
  ──────────────────────────────────────── */
  function initATC() {
    on(document, 'click', async function(e) {
      /* ─ Main ATC button ─ */
      var atcBtn = e.target.closest('.js-add-to-cart');
      if (atcBtn) {
        e.preventDefault();
        e.stopPropagation();
        await handleATC(atcBtn);
        return;
      }

      /* ─ Sticky ATC button ─ */
      var stickyBtn = e.target.closest('[data-sticky-atc]');
      if (stickyBtn) {
        e.preventDefault();
        e.stopPropagation();
        var mainBtn = qs('.js-add-to-cart');
        if (mainBtn) await handleATC(mainBtn);
        return;
      }

      /* ─ Quick add on collection grid ─ */
      var quickBtn = e.target.closest('.js-quick-add');
      if (quickBtn) {
        e.preventDefault();
        await handleQuickAdd(quickBtn);
        return;
      }
    });

    /* NOTE: We intentionally do NOT block native form submit here.
       GoKwik SDK intercepts form submissions to trigger its checkout popup.
       Blocking submit breaks GoKwik entirely. */
  }

  /* ────────────────────────────────────────
     BUY NOW — calls GoKwik's onBuyNowClick directly
     GoKwik SDK injects window.onBuyNowClick globally.
     Original working button had:
       onclick='onBuyNowClick(this,"#BuyButtons-ProductForm-template--…__main")'
     We replicate that exact call.
  ──────────────────────────────────────── */
  function initBuyNow() {
    var buyBtn = qs('#gokwik-buy-now');
    if (!buyBtn) return;

    buyBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();

      var variantId = getActiveVariantId();
      if (!variantId) { console.warn('EDA: No variant ID for buy now'); return; }

      /* Sync the form's hidden variant input so GoKwik reads the right variant */
      var hiddenInput = qs('.js-variant-id');
      if (hiddenInput) hiddenInput.value = String(variantId);
      var qtyInput = qs('.js-qty-input');
      if (qtyInput) qtyInput.value = String(getActiveQty());

      /* Find the product form — GoKwik needs the selector */
      var form = qs('form[data-product-form]')
        || qs('form[id^="product-form-"]')
        || qs('form[id^="ProductForm-"]')
        || qs('form[action*="/cart/add"]');
      var formSelector = form ? '#' + form.id : '';

      /* Show loading state */
      var loader = buyBtn.querySelector('.addloadr');
      var textSpan = buyBtn.querySelector('.btn-text');
      if (loader) loader.style.display = 'inline-flex';
      if (textSpan) textSpan.style.opacity = '0';

      function resetBtn() {
        if (loader) loader.style.display = 'none';
        if (textSpan) textSpan.style.opacity = '1';
      }

      /* Call GoKwik's own function — this is what their injected button does */
      if (typeof window.onBuyNowClick === 'function') {
        try {
          window.onBuyNowClick(buyBtn, formSelector);
        } catch(ex) {
          console.error('GoKwik onBuyNowClick error:', ex);
        }
        /* Reset after a delay — GoKwik popup should be open by then */
        setTimeout(resetBtn, 3000);
        return;
      }

      /* GoKwik SDK may not be loaded yet — wait up to 3s with retries */
      var attempts = 0;
      var maxAttempts = 6;
      var retryInterval = setInterval(function() {
        attempts++;
        if (typeof window.onBuyNowClick === 'function') {
          clearInterval(retryInterval);
          try {
            window.onBuyNowClick(buyBtn, formSelector);
          } catch(ex) {
            console.error('GoKwik onBuyNowClick error:', ex);
          }
          setTimeout(resetBtn, 3000);
          return;
        }
        if (attempts >= maxAttempts) {
          clearInterval(retryInterval);
          console.warn('EDA: GoKwik SDK not available — submitting form natively');
          resetBtn();
          /* Last resort: submit the product form natively — GoKwik may
             intercept form submissions even if onBuyNowClick isn't available */
          if (form) {
            form.submit();
          }
        }
      }, 500);
    });
  }

  async function handleATC(btn) {
    var variantId = getActiveVariantId();
    if (!variantId) { console.warn('EDA: No variant ID found'); return; }

    var qty = getActiveQty();
    var textEl = btn.querySelector('.js-atc-text');
    var orig = textEl ? textEl.textContent : btn.textContent;

    btn.disabled = true;
    if (textEl) textEl.textContent = 'adding…';
    else btn.textContent = 'adding…';

    try {
      await Cart.add(variantId, qty);
      if (textEl) textEl.textContent = 'added ✓';
      else btn.textContent = 'added ✓';
      await openDrawerWithRefresh();
      setTimeout(function() {
        if (textEl) textEl.textContent = orig;
        else btn.textContent = orig;
        btn.disabled = false;
      }, 1800);
    } catch (err) {
      console.error('ATC error:', err);
      if (textEl) textEl.textContent = 'try again';
      else btn.textContent = 'try again';
      setTimeout(function() {
        if (textEl) textEl.textContent = orig;
        else btn.textContent = orig;
        btn.disabled = false;
      }, 2000);
    }
  }

  async function handleQuickAdd(btn) {
    var id = btn.dataset.variantId;
    if (!id) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    try {
      await Cart.add(id, 1);
      btn.textContent = '✓';
      await openDrawerWithRefresh();
      setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 1800);
    } catch(ex) {
      btn.textContent = orig;
      btn.disabled = false;
    }
  }

  function getActiveVariantId() {
    var hiddenInput = qs('.js-variant-id');
    if (hiddenInput && hiddenInput.value && hiddenInput.value !== '0') {
      return hiddenInput.value;
    }
    var anyIdInput = qs('input[name="id"]');
    if (anyIdInput && anyIdInput.value && anyIdInput.value !== '0') {
      return anyIdInput.value;
    }
    var variants = getVariants();
    if (variants.length) return String(variants[0].id);
    return null;
  }

  function getActiveQty() {
    var display = qs('.js-qty-display');
    if (display) return parseInt(display.textContent, 10) || 1;
    var input = qs('.js-qty-input') || qs('[name="quantity"]');
    if (input) return parseInt(input.value, 10) || 1;
    return 1;
  }

  function getVariants() {
    try {
      var el = qs('[id^="ProductVariants-"]');
      return el ? JSON.parse(el.textContent) : [];
    } catch (e) { return []; }
  }

  /* ────────────────────────────────────────
     QTY SELECTOR
  ──────────────────────────────────────── */
  function initQty() {
    on(document, 'click', function(e) {
      var dec = e.target.closest('.js-qty-dec');
      var inc = e.target.closest('.js-qty-inc');
      if (!dec && !inc) return;

      var display = qs('.js-qty-display');
      var input   = qs('.js-qty-input');
      var priceEl = qs('.js-atc-price');

      var qty = parseInt(display ? display.textContent : '1', 10);
      qty = dec ? Math.max(1, qty - 1) : qty + 1;

      if (display) display.textContent = qty;
      if (input)   input.value = qty;

      var variantId = getActiveVariantId();
      var variants  = getVariants();
      var match     = variants.find(function(v) { return String(v.id) === String(variantId); });
      if (match && priceEl) priceEl.textContent = formatMoney(match.price * qty);

      var stickyPrice = qs('.js-atc-price-sticky');
      if (match && stickyPrice) stickyPrice.textContent = formatMoney(match.price * qty);
    });
  }

  /* ────────────────────────────────────────
     GALLERY THUMBNAILS
  ──────────────────────────────────────── */
  function initGallery() {
    on(document, 'click', function(e) {
      var thumb = e.target.closest('.js-thumb-btn');
      if (!thumb) return;
      var id = thumb.dataset.mediaId;
      if (!id) return;

      qsa('.js-thumb-btn').forEach(function(b) {
        b.classList.remove('is-active');
        b.style.borderColor = 'transparent';
      });
      thumb.classList.add('is-active');
      thumb.style.borderColor = '#24221E';

      qsa('.js-gallery-img').forEach(function(img) {
        img.style.display = (img.dataset.mediaId === id) ? '' : 'none';
      });
    });
  }

  /* ────────────────────────────────────────
     VARIANT PICKER
  ──────────────────────────────────────── */
  function initVariants() {
    on(document, 'click', function(e) {
      var btn = e.target.closest('.js-variant-option');
      if (!btn) return;

      var pos = btn.dataset.option;

      qsa('.js-variant-option[data-option="' + pos + '"]').forEach(function(b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.style.background  = active ? '#24221E' : '#FBF9F5';
        b.style.color       = active ? '#FBF9F5' : '#24221E';
        b.style.borderColor = active ? '#24221E' : '#DFD7C8';
      });

      var selections = {};
      qsa('.js-variant-option.is-active').forEach(function(b) {
        selections[b.dataset.option] = b.dataset.value;
      });

      var variants = getVariants();
      var match = variants.find(function(v) {
        return Object.keys(selections).every(function(p) {
          return v['option' + p] === selections[p];
        });
      });
      if (!match) return;

      /* Update ALL hidden id inputs — the form's input AND our js-variant-id */
      qsa('input.js-variant-id, input[name="id"]').forEach(function(inp) {
        if (inp.type === 'hidden') inp.value = String(match.id);
      });

      /* Update price display */
      var priceEl   = qs('.js-price');
      var compareEl = qs('.js-compare-price');
      var savingsEl = qs('.js-savings');
      var atcPrice  = qs('.js-atc-price');
      var stickyP   = qs('.js-atc-price-sticky');
      var prepaidEl = qs('.js-prepaid-price');
      var atcText   = qs('.js-atc-text');
      var atcBtn    = qs('.js-add-to-cart');

      if (priceEl)   priceEl.textContent   = formatMoney(match.price);
      if (atcPrice)  atcPrice.textContent  = formatMoney(match.price);
      if (stickyP)   stickyP.textContent   = formatMoney(match.price);
      if (prepaidEl) prepaidEl.textContent = formatMoney(Math.round(match.price * 0.95));

      if (match.compare_at_price > match.price) {
        if (compareEl) { compareEl.textContent = formatMoney(match.compare_at_price); compareEl.style.display = ''; }
        if (savingsEl) { savingsEl.textContent = 'save ' + formatMoney(match.compare_at_price - match.price); savingsEl.style.display = ''; }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (savingsEl) savingsEl.style.display = 'none';
      }

      if (atcBtn) {
        atcBtn.disabled = !match.available;
        if (atcText) atcText.textContent = match.available ? 'add to cart' : 'sold out';
      }

      /* Update URL */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      } catch(ex) {}

      /* Switch gallery image if variant has featured image */
      if (match.featured_image && match.featured_image.id) {
        var galleryImg = qs('.js-gallery-img[data-media-id="' + match.featured_image.id + '"]');
        if (galleryImg) {
          qsa('.js-gallery-img').forEach(function(img) { img.style.display = 'none'; });
          galleryImg.style.display = '';
          qsa('.js-thumb-btn').forEach(function(b) {
            var isActive = b.dataset.mediaId === String(match.featured_image.id);
            b.classList.toggle('is-active', isActive);
            b.style.borderColor = isActive ? '#24221E' : 'transparent';
          });
        }
      }
    });
  }

  /* ────────────────────────────────────────
     STICKY ATC (PDP)
  ──────────────────────────────────────── */
  function initStickyATC() {
    var bar = qs('.js-sticky-atc');
    if (!bar) return;

    var mainBtn = qs('.js-add-to-cart');
    if (mainBtn && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          bar.style.display = entry.isIntersecting ? 'none' : 'block';
        });
      }, { threshold: 0 });
      obs.observe(mainBtn);
    }
  }

  /* ────────────────────────────────────────
     MOBILE NAV
  ──────────────────────────────────────── */
  function initNav() {
    var toggle = qs('.js-menu-toggle');
    var menu   = qs('#MobileMenu');
    if (!toggle || !menu) return;

    on(toggle, 'click', function() {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });

    on(document, 'click', function(e) {
      if (!menu.classList.contains('is-open')) return;
      if (!menu.contains(e.target) && !toggle.contains(e.target)) {
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });

    on(document, 'keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ────────────────────────────────────────
     CART PAGE (full page cart)
  ──────────────────────────────────────── */
  function initCartPage() {
    on(document, 'click', async function(e) {
      var dec = e.target.closest('.js-cart-item-dec');
      var inc = e.target.closest('.js-cart-item-inc');
      if (!dec && !inc) return;
      var line = parseInt((dec || inc).dataset.line, 10);
      var row  = qs('.cart-item[data-line="' + line + '"]');
      var qtyEl = row && row.querySelector('span');
      var cur  = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
      await Cart.change(line, dec ? Math.max(0, cur - 1) : cur + 1);
      window.location.reload();
    });
  }

  /* ────────────────────────────────────────
     SMOOTH SCROLL
  ──────────────────────────────────────── */
  function initSmoothScroll() {
    on(document, 'click', function(e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ────────────────────────────────────────
     INIT
  ──────────────────────────────────────── */
  function init() {
    initNav();
    initDrawer();
    initATC();
    initBuyNow();
    initQty();
    initGallery();
    initVariants();
    initStickyATC();
    initCartPage();
    initSmoothScroll();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', EDA.init);

document.addEventListener('click', function (event) {
  var checkoutButton = event.target.closest('#DrawerCheckout');

  if (!checkoutButton) return;

  event.preventDefault();
  event.stopPropagation();

  window.location.href = '/cart';
}, true);